module.exports = function() {
  return new Worker("/" + "less-transpiler.3d40a6c3.worker.js");
};